import { defineStore } from 'pinia';
import { usdt_abi, token_abi, swap_abi } from '@/utils/ABI';
import { commonStore } from './common';
// const common_store = commonStore();
import { balanceUtil } from '@/utils/index.js';
import Web3 from 'web3';
const usdt_addr = '0x55d398326f99059fF775485246999027B3197955';
const token_addr = '0x9F2Ae1cce873447e874Eb1bacD13a24103e672bE';
const swap_addr = '0x34e98Af4D093E919302C864D150787E9A3DbA8e6';
export const swapStore = defineStore('swap', {
  state: () => {
    return {
      usdtMethods: {},
      usdtEmpower: false,
      tokenMethods: {},
      swapMethods: {},
      tokenEmpower: false,
      nftSpender: '0x80B03Efc7f874717FEEfA849115f1CFe6d1C12bb',
      marketSpender: '0x35cb37474c3924Bb5458136949c64F46fAc2E074',
      swapSpender: '0x34e98Af4D093E919302C864D150787E9A3DbA8e6',
      hasEmpower:
        (sessionStorage.getItem('tokenEmpower') &&
          sessionStorage.getItem('tokenEmpower') != 'false') ||
        false,
      address: sessionStorage.getItem('address'),
      marketEmpower:
        (sessionStorage.getItem('marketEmpower') &&
          sessionStorage.getItem('marketEmpower') != 'false') ||
        false,
      swapEmpower:
        (sessionStorage.getItem('swapEmpower') &&
          sessionStorage.getItem('swapEmpower') != 'false') ||
        false,
      usdtMarketEmpower:
        (sessionStorage.getItem('usdtMarketEmpower') &&
          sessionStorage.getItem('usdtMarketEmpower') != 'false') ||
        false,
      balacne: '',
    };
  },
  actions: {
    async getBalance() {
      const common_store = commonStore();
      const balance = await this.tokenMethods
        .balanceOf(common_store.address)
        .call();
      this.balacne = balance > 0 ? balanceUtil(balance + '') : balance;
    },
    setEmpower() {
      this.hasEmpower = true;
      sessionStorage.setItem('tokenEmpower', true);
    },
    setMarketEmpower() {
      this.marketEmpower = true;
      sessionStorage.setItem('marketEmpower', true);
    },
    setUsdtEmpower() {
      this.usdtMarketEmpower = true;
      sessionStorage.setItem('usdtMarketEmpower', true);
    },
    async getSwapMethods() {
      const common_store = commonStore();
      const walletObj =
        common_store.walletType == 'BinanceChain'
          ? window.BinanceChain
          : window.ethereum;
      const web3 = new Web3(walletObj);
      const rpoContract = new web3.eth.Contract(swap_abi, swap_addr);
      this.swapMethods = rpoContract.methods;
    },
    async getUsdtMethods() {
      const common_store = commonStore();
      const walletObj =
        common_store.walletType == 'BinanceChain'
          ? window.BinanceChain
          : window.ethereum;
      const web3 = new Web3(walletObj);
      const rpoContract = new web3.eth.Contract(usdt_abi, usdt_addr);
      this.usdtMethods = rpoContract.methods;

      //改为swap合约授权
      const marketEmpower = await this.usdtMethods
        .allowance(common_store.address, this.swapSpender)
        .call();
      this.usdtMarketEmpower = +marketEmpower > 1000000 * 1e18;
      sessionStorage.setItem('usdtMarketEmpower', this.usdtMarketEmpower);
      this.usdtEmpower = true;
    },
    async getTokenMethods() {
      const common_store = commonStore();
      const walletObj =
        common_store.walletType == 'BinanceChain'
          ? window.BinanceChain
          : window.ethereum;
      const web3 = new Web3(walletObj);

      const rpoContract = new web3.eth.Contract(token_abi, token_addr);
      this.tokenMethods = rpoContract.methods;

      const res = await this.tokenMethods
        .allowance(common_store.address, this.nftSpender)
        .call();
      const marketEmpower = await this.tokenMethods
        .allowance(common_store.address, this.marketSpender)
        .call();
      //改为swap合约授权
      const swapEmpower = await this.tokenMethods.allowance(
        common_store.address,
        this.swapSpender
      );
      this.hasEmpower = +res > 1000000 * 1e18;
      sessionStorage.setItem('tokenEmpower', this.hasEmpower);
      this.marketEmpower = +marketEmpower > 1000000 * 1e18;
      this.swapEmpower = +swapEmpower > 1000000 * 1e18;
      sessionStorage.setItem('swapEmpower', this.swapEmpower);
      sessionStorage.setItem('marketEmpower', this.marketEmpower);
      this.tokenEmpower = true;
    },
  },
});
